import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export const useTeams = create((set, get) => ({
    columns: [
        {
            title: 'FISH',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Mansabi',
            dataIndex: 'role',
            key: 'role',
        },
        {
            title: 'Email yoki login',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: "Tizimga qo'shilgan",
            dataIndex: 'created_at',
            key: 'created_at',
        },
        {
            title: "So'nggi o'zgarish",
            dataIndex: 'updated_at',
            key: 'updated_at',
        },
    ],
    teams: [],
    ed: {},
    setEd: (data) => set({ ed: data }),
    getTeams: () => {
        axios.get('teams').then(data => {
            set({ teams: data.data })
        }).catch(error => {
            message.error("Ma'lumotlarni olishda hatolik")
        })
    },
    addTeam: (team) => {
        axios.post('teams', team).then(() => {
            get().getTeams()
        }).catch(error => {
            message.error("Ma'lumotlarni qo'shishda hatolik")
        })
    },
    editTeam: (team) => {
        axios.put(`teams/${team.id}`, team).then(() => {
            get().getTeams()
        }).catch(error => {
            message.error("Ma'lumotlarni tahrirlashda hatolik")
        })
    },
    deleteTeam: (id) => {
        axios.delete('teams/' + id).then(res => {
            get().getTeams()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'chirishda muammo yuzaga keldi!!!")

        })
    }
}))
